import {
	LaravelResponse,
	PaginatedListFetcherConfig,
	keyToUrl,
	mapPaginatedFetcherConfigToAxiosConfig,
	withDestroyEndpoint,
	withIndexEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
	withUsagesEndpoint,
} from "@dgs/core";
import axios from "axios";
import { RegionIndexResource, RegionSaveRequest, RegionUpdateResource } from "../types/region";

const baseKey = ["regions"];

export const regionService = {
	...withIndexEndpoint<RegionIndexResource>(baseKey),
	...withShowEndpoint<RegionUpdateResource>(baseKey),
	...withStoreEndpoint<RegionSaveRequest>(baseKey),
	...withUpdateEndpoint<RegionSaveRequest>(baseKey),
	...withDestroyEndpoint(baseKey),
	...withUsagesEndpoint(baseKey),
	index: (config: PaginatedListFetcherConfig<any>) =>
		axios.get<LaravelResponse<RegionIndexResource[]>>(keyToUrl(baseKey), {
			params: { ...mapPaginatedFetcherConfigToAxiosConfig(config).params, orderBy: config.sortParams },
		}),
};
